const User = () => {
    return(
        <svg className='user info-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64.24 64.24'>
            <rect width='64.24' height='64.24' rx='7.39' />
            <path d='M32.12,32.12a7.75,7.75,0,1,0-7.75-7.75A7.75,7.75,0,0,0,32.12,32.12Zm5.42,1.94h-1a10.63,10.63,0,0,1-8.83,0h-1a8.13,8.13,0,0,0-8.13,8.13v2.52a2.9,2.9,0,0,0,2.9,2.91H42.77a2.91,2.91,0,0,0,2.91-2.91V42.19A8.13,8.13,0,0,0,37.54,34.06Z' />
        </svg>
    )
}

export default User